import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from "moment";
import { Row, Col, Checkbox, Radio, TimePicker } from "antd";
import AirModal from '../../../../../../common/components/AirModal';
import AirButton from '../../../../../../common/components/AirButton';
import './ManageScheduleModal.css';

@inject('translationsStore', 'groupsStore', 'commonStore')
@observer
export default class ManageScheduleModal extends Component {
  constructor(props) {
    super(props);

    let statusOptions = [{ label: this.props.translationsStore.translate("geofence.status.ENABLED"), value: "ENABLED" }];
    let typeOptions = [{ label: this.props.translationsStore.translate("geofence.type.INSIDE"), value: "INSIDE" }, { label: this.props.translationsStore.translate("geofence.type.OUTSIDE"), value: "OUTSIDE" }, { label: this.props.translationsStore.translate("geofence.type.BOTH"), value: "BOTH" }];
    let daysOptions = [
        { label: this.props.translationsStore.translate("geofence.days.1"), value: "1" },
        { label: this.props.translationsStore.translate("geofence.days.2"), value: "2" },
        { label: this.props.translationsStore.translate("geofence.days.3"), value: "3" },
        { label: this.props.translationsStore.translate("geofence.days.4"), value: "4" },
        { label: this.props.translationsStore.translate("geofence.days.5"), value: "5" },
        { label: this.props.translationsStore.translate("geofence.days.6"), value: "6" },
        { label: this.props.translationsStore.translate("geofence.days.7"), value: "7" },
        ];
    this.state = {
      visible: false,
      schedule: { 
        type: "",
        status: ["DISABLED"],
        days: [], 
        isDeletable: "false"
      },
      statusOptions: statusOptions,
      typeOptions: typeOptions,
      daysOptions: daysOptions
    };
  }

  componentDidMount() { 
  }

  reset = () => {
    let defaultSchedule = {
        key: new Date().getUTCMilliseconds(),
        type: null,
        status: [],
        days: [],
        timeStart: moment("06:00", "HH:mm"),
        timeEnd: moment("23:00", "HH:mm")
    };
    this.setState({ schedule: defaultSchedule });
  }

  show = (schedule) => {
    this.setState({ visible: true, schedule: schedule });
  };

  close = () => {
    this.setState({ visible: false });
  };

  onChangeScheduleType = e => {
    let schedule = this.state.schedule;
    schedule.type = e.target.value;
    this.setState({
        schedule: schedule
    });
  };

  onChangeScheduleStatus = checkedList => {
    let schedule = this.state.schedule;
    if (checkedList === null || checkedList.length === 0 || checkedList === [""]) {
      checkedList = ["DISABLED"];
    }
    schedule.status = checkedList;
    this.setState({
        schedule: schedule
    });
  }

  onChangeScheduleDays = checkedList => {
    let schedule = this.state.schedule;
    schedule.days = checkedList;
    this.setState({
        schedule: schedule
    });
  }

  onChangeScheduleTimeStart = (time, timeString) => {
    let schedule = this.state.schedule;
    schedule.timeStart = time;
    this.setState({
        schedule: schedule
    });
  }

  onChangeScheduleTimeEnd = (time, timeString) => {
    let schedule = this.state.schedule;
    schedule.timeEnd = time;
    this.setState({
        schedule: schedule
    });
  }

  updateGeofenceSchedule = () => {
    if (this.state.schedule.type !== null && this.state.schedule.type !== "" && this.state.schedule.days.length > 0) {
      let schedule = this.state.schedule;
      this.props.onUpdate(schedule);
      this.close();
    }
  }

  render() {
    const { translationsStore } = this.props;
    return (
      <div className="ManageScheduleModal">
        <AirModal
          className="ManageScheduleModal"
          visible={this.state.visible}
          cancelButton={<AirButton size="large" label={translationsStore.translate('geofence.detail.manageSchedule.cancel')} />}
          onCancel={this.close}
          okButton={<AirButton size="large" light="true" label={translationsStore.translate('geofence.detail.manageSchedule.update')} disabled={this.state.schedule.type === null || this.state.schedule.type === [] || this.state.schedule.days.length === 0} />}
          onOk={this.updateGeofenceSchedule}
          title={translationsStore.translate('geofence.detail.manageSchedule.title')}
          subtitle={translationsStore.translate('geofence.detail.manageSchedule.subtitle')}
          width="676px"
        >
          <div>
            <Row>
                <Col span={24}>
                    <Col span={12}>
                        <div className="title">{translationsStore.translate('geofence.detail.manageSchedule.labelType')} *</div>
                        <div className="checkbox schedule_type">
                            <Radio.Group options={this.state.typeOptions} onChange={this.onChangeScheduleType} value={this.state.schedule.type}/>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div className="title">{translationsStore.translate('geofence.detail.manageSchedule.labelStatus')}</div>
                        <div className="checkbox schedule_status">
                            <Checkbox.Group options={this.state.statusOptions} onChange={this.onChangeScheduleStatus} value={this.state.schedule.status}/>
                        </div>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="title">{translationsStore.translate('geofence.detail.manageSchedule.labelDays')} *</div>
                    <div className="checkbox schedule_days">
                        <Checkbox.Group options={this.state.daysOptions} onChange={this.onChangeScheduleDays} value={this.state.schedule.days}/>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="title">{translationsStore.translate('geofence.detail.manageSchedule.labelTimeOfDay')} *</div>
                    <Col span={6}>
                        <div className="timeOfDay">
                            <TimePicker format="HH:mm" defaultValue={moment("06:00", "HH:mm")} value={moment(this.state.schedule.timeStart, "HH:mm")} onChange={this.onChangeScheduleTimeStart} allowClear={false}/>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="timeOfDay">
                        <TimePicker format="HH:mm" defaultValue={moment("06:00", "HH:mm")} value={moment(this.state.schedule.timeEnd, "HH:mm")} onChange={this.onChangeScheduleTimeEnd} allowClear={false}/>
                        </div>
                    </Col>
                </Col>
            </Row>
          </div>
        </AirModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/GeofenceForm/ManageScheduleModal/ManageScheduleModal.js